import { render, staticRenderFns } from "./medics.vue?vue&type=template&id=7b4adabf&scoped=true&"
import script from "./medics.vue?vue&type=script&lang=js&"
export * from "./medics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4adabf",
  null
  
)

export default component.exports